module.exports = __webpack_public_path__ + "static/media/eman.4beb2517.jpeg";